// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  hmr: false,
  apiUrl: "http://localhost:4000",
  /*
  chain: {
    id: "0x61",
    name: "Binance Smart Chain - TestNet",
    rpc: [
      "https://bsc.getblock.io/testnet/?api_key=b36aa7df-8b56-43bc-a420-cd2fe6328575",
    ],
    nativeCurrency: {
      name: "TBNB",
      symbol: "TBNB", // 2-6 characters long
      decimals: 18,
    },
    blockExplorerUrls: ["https://testnet.bscscan.com/"],
  },*/
  chain: {
    id: "0x38",
    name: "Binance Smart Chain",
    rpc: [
      "https://bsc.getblock.io/mainnet/?api_key=b36aa7df-8b56-43bc-a420-cd2fe6328575",
    ],
    nativeCurrency: {
      name: "BNB",
      symbol: "BNB", // 2-6 characters long
      decimals: 18,
    },
    blockExplorerUrls: ["https://bscscan.com/"],
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
